var _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _rect, _polygon, _path, _rect2, _polygon2, _rect3, _rect4, _rect5, _polygon3, _rect6, _rect7, _rect8, _polygon4, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformerPowerVoltageEnergyElectronicSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8f6c56;}.cls-2{fill:#f4ecce;}.cls-3{fill:#fcdd7c;}.cls-4{fill:#65c8d0;}.cls-5{fill:#838bc5;}.cls-6{fill:#ba9bc9;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34 15 36 19 28 19 30 15"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22 15 24 19 16 19 18 15"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46 15 48 19 40 19 42 15"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34 11 36 15 28 15 30 11"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "22 11 24 15 16 15 18 11"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "46 11 48 15 40 15 42 11"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 28,
    width: 44,
    x: 10,
    y: 27
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42 51 22 51 32 31 42 51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.89,48.45l-1.78-.9L32.38,45H30a1,1,0,0,1-.89-1.45l2-4,1.78.9L31.62,43H34a1,1,0,0,1,.89,1.45Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 6,
    width: 50,
    x: 7,
    y: 55
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36 11 28 11 30 7 34 7 36 11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 31,
    y: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 29,
    y: 19
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 33,
    y: 19
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24 11 16 11 18 7 22 7 24 11"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 19,
    y: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 17,
    y: 19
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 21,
    y: 19
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48 11 40 11 42 7 46 7 48 11"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 43,
    y: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 41,
    y: 19
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4,
    width: 2,
    x: 45,
    y: 19
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4,
    rx: 2,
    width: 48,
    x: 8,
    y: 23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformerPowerVoltageEnergyElectronicSvgrepoCom);
export default __webpack_public_path__ + "static/media/transformer-power-voltage-energy-electronic-svgrepo-com.e5fd24996752159a526aaf6fa4fa739e.svg";
export { ForwardRef as ReactComponent };